// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__2nTb8","buttons":"SendReceipts_buttons__11dQQ","email":"SendReceipts_email__bNll-","bookApptTitle":"SendReceipts_bookApptTitle__iADax"};